import React from 'react';
import {
    OnboardingStepLinksButton,
    OnboardingStepLinksItem,
    OnboardingStepLinksLink,
    OnboardingStepLinksWrapper,
} from './styles';
import { OnboardingStepLinksProps } from './types';

export const OnboardingStepLinks = ({ links }: OnboardingStepLinksProps): JSX.Element => (
    <OnboardingStepLinksWrapper>
        {links?.map(({ href, icon, label, target }) => (
            <OnboardingStepLinksItem key={href}>
                <OnboardingStepLinksLink href={href} target={target}>
                    <OnboardingStepLinksButton startIcon={icon} text={label} disableSentenceCase />
                </OnboardingStepLinksLink>
            </OnboardingStepLinksItem>
        ))}
    </OnboardingStepLinksWrapper>
);
